import { from, Observable } from 'rxjs';
import { shareReplay, switchMap, tap } from 'rxjs/operators';
import { isArdoqError, type Result } from '@ardoq/common-helpers';
import type { FutureStateUpdatedResponse } from '@ardoq/api-types';
import { api, transformationsApi } from '@ardoq/api';
import { action$, extractPayload, ofType } from '@ardoq/rxbeach';
import { trackEventV2 } from 'tracking/tracking';
import { updateFutureStateRequested } from './futureStatePageForm$/actions';
import { dispatchDetectedSetupStatus } from '../setupStatusDetection';

export const updateFutureState$: Observable<
  Result<FutureStateUpdatedResponse>
> = action$.pipe(
  ofType(updateFutureStateRequested),
  extractPayload(),
  switchMap(({ field, ...request }) =>
    from(transformationsApi.updateFutureState(request)).pipe(
      tap(response => {
        if (!isArdoqError(response)) {
          trackEventV2({
            event: 'Future State0 Updated future state',
            payload: { field },
          });
        }
      })
    )
  ),
  tap(response => {
    dispatchDetectedSetupStatus(response);
    api.logErrorIfNeeded(response);
  }),
  shareReplay({ bufferSize: 1, refCount: true })
);
